import React from 'react';
import Image from 'next/image';
import clsx from 'clsx';
import { X } from 'lucide-react';
import Icons from '@/const/icons';

interface TourStepHeaderProps {
	onClose: () => void;
	className?: string;
	children?: React.ReactNode;
}

export const TourStepHeader: React.FC<TourStepHeaderProps> = ({
	onClose,
	className,
	children,
}) => (
	<div className={clsx('relative flex items-center justify-center', className)}>
		<Image
			src={Icons.bubblesTour}
			alt=""
			width={720}
			height={478}
			className="absolute left-0 w-full h-auto -z-10 -top-1 md:-top-0"
		/>

		<button
			type="button"
			onClick={onClose}
			className="absolute right-6 top-6 outline-none z-10"
		>
			<X className="w-6 h-6 text-[#292D32]" />
		</button>

		{children}
	</div>
);
